import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { fuseAnimations } from '@mobileia/layout-fuse';
import { BaseViewComponent } from '../base-view/base-view.component';
import { Transaction } from 'src/app/entities/transaction';
import { TransactionService } from 'src/app/services/transaction.service';
import { Router, ActivatedRoute } from '@angular/router';
import { AlertService } from 'src/app/services/alert.service';
import { GoogleStorageService } from 'src/app/services/google-storage.service';

@Component({
  selector: 'app-transaction-view',
  templateUrl: './transaction-view.component.html',
  styleUrls: ['./transaction-view.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations
})
export class TransactionViewComponent extends BaseViewComponent<Transaction> implements OnInit {

  pathUrlList = 'transaction';
  isUploading = false;

  constructor(
    protected transactionService: TransactionService,
    protected alertService: AlertService,
    protected route: ActivatedRoute,
    protected navigator: Router,
    protected googleService: GoogleStorageService
  ) {
    super(alertService, route, navigator);
    this.service = transactionService;
  }

  onChangeStatus() {
    this.transactionService.changeStatus(this.item.id, this.item.status).toPromise().then();
  }

  onClickSend() {
    this.transactionService.sendInvoice(this.item.id).toPromise().then();
    this.alertService.showSuccess('Exito!', 'Se ha enviado correctamente!.');
  }

  getAdditional() {
    return parseFloat(this.item.additional) - parseFloat(this.item.delivery);
  }

  onUploadFiles(files) {
    for (let i = 0; i < files.length; i++) {
      const element = files[i];
      this.onUploadFile(element);
    }
  }

  onUploadFile(file) {
    this.isUploading = true;
    this.googleService.upload(file).toPromise().then(data => {
      this.isUploading = false;
      if (!data.success) {
        return;
      }

      this.item.invoice_pdf = data.response.url;
      this.transactionService.saveInvoice(this.item.id, this.item.invoice_pdf).toPromise().then();
    });
  }

  getStatusLabel(status: number): string {
    const statusMap = {
      0: 'Pendiente',
      1: 'Pagado',
      2: 'Cancelado',
      4: 'Pagado Confirmado',
      5: 'Envío Pendiente',
      6: 'Entregado'
    };
    return statusMap[status] || 'Desconocido';
  }

  getStatusClass(status: number): string {
    const classMap = {
      0: 'status-pending',
      1: 'status-paid',
      2: 'status-cancelled',
      4: 'status-confirmed',
      5: 'status-shipping',
      6: 'status-delivered'
    };
    return classMap[status] || '';
  }
}
